(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  'use strict';

  // ── Announcement cycling ─────────────────────────────────────
  const announcementBar = document.querySelector('.co-footer__announcements');

  if (announcementBar) {
    const items = Array.from(
      announcementBar.querySelectorAll('.co-footer__announcement')
    );

    if (items.length > 1) {
      let current = 0;

      setInterval(() => {
        items[current].setAttribute('aria-hidden', 'true');
        current = (current + 1) % items.length;
        items[current].setAttribute('aria-hidden', 'false');
      }, 4000);
    }
  }

  // ── Tab switching ─────────────────────────────────────────────
  // Single event listener on the tablist — event delegation
  const tabList = document.querySelector('.co-footer__nav-tabs');

  if (tabList) {
    tabList.addEventListener('click', (e) => {
      const tab = e.target.closest('.co-footer__tab-btn');
      if (!tab) return;

      const panelId = tab.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      // Deactivate all tabs and panels
      tabList.querySelectorAll('.co-footer__tab-btn').forEach((t) => {
        t.setAttribute('aria-expanded', 'false');
      });

      document.querySelectorAll('.co-footer__panel').forEach((p) => {
        p.setAttribute('aria-hidden', 'true');
      });

      // Activate selected tab and panel
      tab.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
    });
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // ── DESKTOP TABS ──────────────────────────────────────────────
  // Single delegated listener per nav — no per-button handlers
  document.querySelectorAll('.it__nav').forEach(function (nav) {
    nav.addEventListener('click', function (e) {
      var tab = e.target.closest('.it__tab-btn');
      if (!tab) return;

      var panelId = tab.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (!panel) return;

      var desktop = nav.closest('.it__desktop');

      desktop.querySelectorAll('.it__tab-btn').forEach(function (t) {
        t.setAttribute('aria-selected', 'false');
      });
      desktop.querySelectorAll('.it__panel').forEach(function (p) {
        p.setAttribute('aria-hidden', 'true');
      });

      tab.setAttribute('aria-selected', 'true');
      panel.setAttribute('aria-hidden', 'false');
    });
  });

  // ── MOBILE ACCORDION ──────────────────────────────────────────
  var REVEAL_MS = 350;   // matches the panel's grid-template-rows transition
  var REVEAL_GAP = 12;   // breathing room under the sticky header
  var REVEAL_PAD = 24;   // .it__rte padding-bottom, animates in with the panel

  // Visible bottom edge of the header. Measured, not derived from
  // --headerHeight: the section wrapper is a fixed 84px on mobile that
  // includes empty space below the rendered nav, so measure whichever
  // inner element is actually on screen (same approach as filter-drawer.js).
  function headerBottom() {
    var sec = document.getElementById('shopify-section-header');
    if (!sec) return 0;
    var el = sec;
    var inner =
      sec.querySelector('.mobile-navigation-wrapper') ||
      sec.querySelector('sticky-header') ||
      sec.querySelector('.header-wrapper');
    if (inner) {
      var cs = getComputedStyle(inner);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' &&
          inner.getBoundingClientRect().height > 0) el = inner;
    }
    return Math.max(0, el.getBoundingClientRect().bottom);
  }

  // Where the opened heading should end up. Centre the whole group
  // (heading + its panel) when it fits under the header — short tabs read
  // as composed. Otherwise top-align the heading, which puts the most
  // content on screen.
  function revealTop(btnH, panelH) {
    var top = headerBottom() + REVEAL_GAP;
    var usable = window.innerHeight - top;
    var group = btnH + panelH;
    return group < usable ? top + (usable - group) / 2 : top;
  }

  /* Bring the opened tab into view.

     One native scroll, announced to the rest of the page. The delta is already
     computed by the caller (it centres the heading + its panel when they fit,
     otherwise top-aligns the heading), so this only has to move.

     window.__coScrollLock is what makes this safe. During a programmatic scroll
     the visual viewport lags the layout scroll, so visualViewport.offsetTop
     reads non-zero with no browser chrome actually overlaying. That value is
     the sticky chain's `top`, so the chain was pushed down and left a strip of
     page background above the announcement bar — the reason this was disabled.
     The URL-bar tracker and the header hide/show handler both stand down while
     the flag is set, and the tracker takes one settled reading afterwards.

     A counter, not a boolean, so overlapping scrolls cannot release it early. */
  function releaseScrollLock() {
    window.__coScrollLock = Math.max(0, (window.__coScrollLock || 1) - 1);
  }

  function glideBy(delta) {
    if (Math.abs(delta) < 8) return; // already well placed — don't move for nothing

    window.__coScrollLock = (window.__coScrollLock || 0) + 1;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: window.scrollY + delta,
      left: 0,
      behavior: reduce ? 'instant' : 'smooth'
    });

    /* Release when the scroll actually finishes where that is reported, with a
       timeout as the backstop — a smooth scroll's duration is the browser's to
       choose, and scrollend only shipped in Safari 18. Whichever fires first. */
    var released = false;
    var done = function () {
      if (released) return;
      released = true;
      window.removeEventListener('scrollend', done);
      releaseScrollLock();
    };
    if ('onscrollend' in window) window.addEventListener('scrollend', done);
    setTimeout(done, reduce ? 60 : 900);
  }



  // Single delegated listener per accordion — no per-button handlers
  document.querySelectorAll('.it__accordion').forEach(function (accordion) {
    accordion.addEventListener('click', function (e) {
      var btn = e.target.closest('.it__accordion-btn');
      if (!btn) return;

      var item = btn.closest('.it__accordion-item');
      var contentId = btn.getAttribute('aria-controls');
      var content = document.getElementById(contentId);
      if (!content) return;

      var isOpen = item.dataset.open === 'true';

      // Measure BEFORE mutating. Opening is exclusive, so a panel open
      // ABOVE the clicked heading collapses and drags that heading upward
      // by its height — an uncorrected jump that made the accordion feel
      // unsettled. Both motions run for the same 350ms, so scrolling to
      // the heading's FINAL position keeps them in step, one movement
      // rather than a lurch after the fact.
      var delta = null;
      if (!isOpen) {
        var btnRect = btn.getBoundingClientRect();
        var collapsing = 0;
        var openItem = accordion.querySelector('.it__accordion-item[data-open="true"]');
        if (openItem && openItem !== item &&
            openItem.getBoundingClientRect().top < btnRect.top) {
          collapsing = openItem
            .querySelector('.it__accordion-content')
            .getBoundingClientRect().height;
        }
        // scrollHeight reports the panel's full height even while it is
        // clipped at 0fr, so the destination is known without waiting for
        // the expansion. Closed panels carry no padding yet — add the
        // padding-bottom that animates in with them.
        var rte = content.querySelector('.it__rte');
        var panelH = rte ? rte.scrollHeight + REVEAL_PAD : 0;
        delta = (btnRect.top - collapsing) - revealTop(btnRect.height, panelH);
      }

      // Close all items first
      accordion.querySelectorAll('.it__accordion-item').forEach(function (i) {
        i.dataset.open = 'false';
        i.querySelector('.it__accordion-btn').setAttribute('aria-expanded', 'false');
        i.querySelector('.it__accordion-content').setAttribute('aria-hidden', 'true');
      });

      // Open the clicked item if it was previously closed
      if (!isOpen) {
        item.dataset.open = 'true';
        btn.setAttribute('aria-expanded', 'true');
        content.setAttribute('aria-hidden', 'false');
        glideBy(delta);
      }
    });
  });

}());

  } catch(e) { console.error(e); }
})();
})();
